/* eslint-disable no-nested-ternary */
import React, {
  useEffect, useMemo, useState,
  useRef,
} from 'react';
import {
  Row, Col, notification, Spin, Layout,
} from 'antd';
import { flushSync } from 'react-dom';
import styled from 'styled-components';
import {
  useLocation, useNavigate, useParams,
  useSearchParams,
} from 'react-router-dom';
import PersonInfo from 'Components/person/components/PersonInfo';
import PersonDetails from 'Components/person/components/PersonDetails';
import Tabs from 'Components/common/tabs/Tabs';
import { actions as flurryActions, actions as helperActions } from 'Slice/HelperSlice';
import BackIcon from 'Components/common/assets/svgIcons/BackIcon';
import PersonalDetails from 'Components/person/components/PersonalDetails';
import PersonCareer from 'Components/person/components/PersonCareer';
import DownloadProfileLanguagePopup from 'Components/common/modal/DownloadProfileLanguagePopup';
import {
  personPersonalityInfo, personCard,
  personSocialLinks, profileLoading, profileFollowLoading,
  personProfileDownloadLoading, personCardPersonId,
  personProfilePopups, navigationTabsPersonProfile,
  selectCardResult, selectSavedProfile, selectLanguagePopup,
  selectSimilarPeopleData,
  selectPersonThemes,
  selectThemeLoading,
  selectShowDigestPopup,
  selectFaqs,
  selectInsightsLoading,
} from 'Selector/PersonProfileSelector';
import {
  useDispatch, useSelector,
} from 'react-redux';
import {
  PersonalityInfo,
  PersonCard,
  PersonPopupResponse,
  PersonResponseType,
  SimilarPeopleData,
  SocialLink,
} from 'Types/PersonTypes';

import { actions as personProfileActions } from 'Slice/PersonProfileSlice';
import { actions as groupActions } from 'Slice/GroupsSlice';
import { actions as affinitySearchActions } from 'Slice/AffinitySearchResultsSlice';
import {
  certificationSmoothBehavior,
  getLocalStorageObject,
  isGuest,
  isSalesforce,
  IsTablet,
  socket,
  haveHistory,
  valueToObject,
  getCurrentTime,
  isGuestfromEmail,
  setLocalStorageValue,
  getStringAfterQueryParam,
  getLangCookie,
  scrollWithId,
  smoothBehavior,
  isElement,
  replaceURLWithoutReload,
  normalizeTagItemToSpan
} from 'Utils/UtilityFunctions';
import {
  GetPersonProfileRequest,
  UpdatePersonProfileFollow,
} from 'Types/RequestBodies';
import PersonalityInsight from 'Components/person/components/PersonalityInsight';
import PersonNews from 'Components/person/components/PersonNews';
import PersonCardSkeleton from 'Components/common/skeleton/PersonCardSkeleton';
import AccountPopOver from 'Components/common/components/AccountPopOver';
import ProfilePopups from 'Components/common/modal/ProfilePopups';
import DrawerPeopleGroup from 'Components/people/components/DrawerPeopleGroup';
import SkeletonCustom from 'Components/common/skeleton/SkeletonCustom';
import NoDataFound from 'Components/common/components/NoDataFound';
import PersonVideos from 'Components/person/components/PersonVideos';
import { selectData } from 'Selector/BranchSelector';
import GuestBanner from 'Components/person/components/GuestBanner';
import LimitReached from 'Components/person/components/LimitReached';
import AlertsStyle from 'Style/AlertsStyle';
import classNames from 'classnames';
import FingerPrint from 'Components/common/components/FingerPrint';
import { actions as certificationActions } from 'Slice/CertificationSlice';
import {
  selectIsScroll, selectScrollToId, selectScrollToPage, selectSearchPersonClicked,
  selectData as certificationData,
  selectHighlight,
  selectActivetype,
  selectIsHighlighted,
  selectToasterFlag,
  selectAiCertificationData,
} from 'Selector/CertificationSelector';
import SubNavBarPrimary from 'Components/layout/headers/SubNavBarPrimary';
import { selectViewTab } from 'Selector/UISelector';
import { StrategicHighlight, ViewInterface } from 'Types/GlobalTypes';
import ViewTabs from 'Components/common/tabs/ViewTabs';
import DisclaimerMessage from 'Components/common/components/DisclaimerMessage';
import {
  BOOK_A_MEETING_LINK,
  DIGEST_FAILED_TOASTER,
  DISCLAIMER_MESSAGE, LanguageEnum, PERSONALITY_INSIGHTS_ROUTE, PERSON_TOASTER,
} from 'Utils/Constants';
import {
  maxMobile, maxTablet, maxWidth, maxWidth1170, primaryColor, retina,
  wMedium,
} from 'Utils/utilsStyle';
import { TagItem } from 'Types/ChatBotV2Types';
import {
  selectDisclessPersonality, selectScreenName, selectShowChatbot, selectShowGlobalGilroy,
} from 'Selector/GlobalSearchContentSelector';
import { selectGuestLoading, selectLoginResp } from 'Selector/GuestSearchSelector';
import isEmpty from 'lodash/isEmpty';
import { GuestLoginDataResponse } from 'Types/GuestSearchResultTypes';
import GuestPopup from 'Components/common/modal/GuestPopup';
import GlobalButton from 'Components/common/components/GlobalButton';
import MeetingIcon from 'Components/common/assets/svgIcons/MeetingIcon';
import { usePrevious } from 'Utils/hooks/usePrevious';
import GilroyPersonHeader from 'Components/chatBotV2/mainComponents/GilroyPersonHeader';
import GenerateDigestPopup from 'Components/common/modal/GenerateDigestPopup';
import { Gilroy } from 'gilroy-global';
import { useGilroy } from 'Utils/hooks/useGilroy';
import { SearchResultsRequest } from 'Types/GlobalSearchResultsTypes';
import {
  peopleData, selectLoading, selectPersonLoaded,
  selectSearchLoaded,
} from 'Selector/GlobalSearchResultsSelector';
import SearchResultPopup from 'Components/common/modal/SearchResultPopup';
import GlobalSearch from '../../Components/globalSearch/components/GlobalSearch';
import NavBarPrimary, { chatActions, chatStates } from '../../Components/layout/headers/NavBarPrimary';
import DrawerAlerts from '../../Components/alerts/components/DrawerAlerts';
import PersonStyle from '../../Style/PersonStyle';
import FeedStyle from '../../Style/FeedStyle';
import { actions as UiAction } from '../../Slice/UISlice';
import { actions as guestActions } from '../../Slice/GuestSlice';
import { actions as searchActions } from '../../Slice/GlobalSearchResultsSlice';
import { actions as companiesActions } from '../../Slice/CompaniesSlice';
import StrategicHighlights from '../../Components/common/components/StrategicHighlights';
import { selectBlip, selectCompanyStrategicHighlights, strategicHighlightsLoading } from '../../Selector/CompaniesSelector';
import { selectCurrentSections } from 'Selector/PersonProfileSelector';
import StrategicHighlightsSkeleton from '../../Components/common/skeleton/StrategicHighlightsSkeleton';

const Wrapper = styled.div<{ personHeader?: number }>`
.personality-insight-wrapper {
  z-index: 0;
  position: relative;
}
&.nutenixPerson {
  .tabSection {
    .personality-insight-wrapper {
      .personality-block-styled-component {
        margin-top: 0px;
      }
    }
  }
  .company-container {
    .company-logo-container {
      display: none;
    }
    .designation-container {
      padding-left: 0px;
      .designation  {
        color: ${primaryColor};
        text-align: center;
        font-weight: ${wMedium};
      }
    }
  }
  .chatbotPersonWrapper {
    .person-image-container {
      .drag-appeaser {
        .name-wrapper {
          display: none !important;
        }
      }
    }
  }
}
  .tabsNav {
    margin-top: 25px;
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;
  }
  .tabSection {
    padding-top: 30px;
  }
  .header-main-wrapper  {
    z-index: 3;
  }
  .sub-header-main-wrapper {
    z-index: 2;
  }
  .main-company-panel {
    @media all and (max-width: ${maxMobile}) {
      position: relative;
    }
  }
  .person-info-detail-row{
  position: relative;
  z-index: 0;
    .first-col-area {
      @media all and (max-width: ${maxMobile}) {
        margin-top: 110px;
      }
    }
    .second-col-area {
      @media all and (max-width: ${maxMobile}) {
      position: initial;
      };
      .social-and-action-here {
        padding-top: 33px;
        display: flex;
        align-items: flex-start;
        @media all and (max-width: ${maxWidth}) , ${retina} {
         padding-top: 20px;
        }
        @media all and (max-width: ${maxMobile}) {
          position: absolute;
          right: 10px;
          top: 0px;
          width: 95%;
        }
      }
    }
  }
  .loader-skeleton {
    @media all and (max-width: ${maxTablet}) {
      padding: 0px 15px;
    }
  }
  .boxDoor {
    @media all and (max-width: ${maxWidth1170}) {
      top: 201px;
    }
  }
  .container-company-card {
    user-select: none;
    .progress-social-div {
       .scc-place {
        width: 25px;
        height: 30px;
        @media all and (max-width: ${maxWidth}) , ${retina} {
          width: 20px;
          height: 20px;
        }
      }
    }
  }
  .container {
    &.bottomAccordion {
      .chatbot-v2 {
        margin-bottom: 200px;
      }
    }
    &.chatbot-container {
      padding-bottom: 5px;
      @media all and (max-width: ${maxTablet}) {
        padding-bottom: 20px;
      }
      .boxDoor {
       @media all and (max-width: ${maxTablet}) {
         display: none;
       }
      }
      &.bottomAccordion {
        .chatbot-v2 {
          margin-bottom: 200px;
        }
      }
      .chatbot-v2 {
        @media all and (max-width: ${maxWidth}), ${retina} {
          margin-bottom: 0px;
        }
      }
    }
  }
  .right-side-wrap {
    .schedule-demo-btn {
      svg {
        margin-right: 7px;
        @media all and (max-width: ${maxWidth}), ${retina}{
          margin-right: 5px;
        }
      }
    }
    &.guestHeader {
      padding-right: 0px;
    }
  }
  .header-wrapper {
    width: 100%;
    .left-side-wrap {
      width: ${(props) => `calc(100% - ${props.personHeader}px)`};
    }
  }
  .person-highlights-wrapper .strategic-highlights-wrapper {
    margin-top: 30px;
    margin-bottom: 0px;
  }
  .tabSection .strategic-highlights-wrapper {
    margin-bottom: 180px;
  }
  .highlight-skeleton {
    padding-top: 30px;
  }
`;

type TabsInterface = {
  [key: string]: JSX.Element;
};

type Params = {
  section: string;
};

type IDX = {
  usr: number;
  key: string;
  idx: number;
};
type PersonObj = {
  personid: number;
  name: string
};

const Person = function Person() {
  const { saveUrl: savedUrlV2 } = chatStates;
  const { gilroyStates, gilroyActions } = useGilroy();
  const { section } = useParams<Params>();
  const prevSection = usePrevious(section);
  const [searchParams] = useSearchParams();
  const personId = Number(searchParams.get('personId')) || 0;
  const personType = searchParams.get('personType') || 'EXECUTIVE';
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [gilroySeedPrompt, setGilroySeedPrompt] = useState<string | undefined>(undefined);
  const [showNew, setShowNew] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [dragging, setDragging] = useState(false);
  const [isPersonSearchVisible, setIsPersonSearchVisible] = useState(false);
  const [backNavigation, setBackNavigation] = useState(-1);
  const loading: boolean = useSelector(profileLoading);
  const guestLoading = useSelector(selectGuestLoading);
  const personProfileCard: PersonCard = useSelector(personCard);
  const personProfileCardPersonId: number = useSelector(personCardPersonId);
  const personProfilePersonalityInfo: PersonalityInfo = useSelector(
    personPersonalityInfo,
  );
  const personProfileSocialLinks: SocialLink[] = useSelector(personSocialLinks);
  const personProfileFollowLoading: boolean = useSelector(profileFollowLoading);
  const personDownloadLoading: boolean = useSelector(
    personProfileDownloadLoading,
  );
  const blip = useSelector(selectBlip);
  const personPopups: PersonPopupResponse = useSelector(personProfilePopups);
  const CardResult: PersonResponseType[] = useSelector(selectCardResult);
  const faqs = useSelector(selectFaqs);
  const host = window.location.href;
  //  Navigation Array
  const navArray: string[] = useSelector(navigationTabsPersonProfile);
  const tabView: ViewInterface = useSelector(selectViewTab);
  const isListView = tabView.view === 'listView';
  const getPath = getLocalStorageObject('ViewTab') as ViewInterface;
  const branchData = useSelector(selectData);
  const { data_parsed: dataParsed } = branchData || {};
  const IsTab = IsTablet();
  const scrollToId: string = useSelector(selectScrollToId);
  const isScroll: boolean = useSelector(selectIsScroll);
  const scrollToPage: string = useSelector(selectScrollToPage);
  const isSearchPerson: boolean = useSelector(selectSearchPersonClicked);
  const data = useSelector(certificationData);
  const toasterFlag = useSelector(selectToasterFlag);
  const [isToaster, setIsToaster] = useState(toasterFlag);
  const isHighlight = useSelector(selectHighlight);
  const currentType = useSelector(selectActivetype);
  const isHighlighted = useSelector(selectIsHighlighted);
  const savedId = useSelector(selectSavedProfile);
  const isLanguagePopup = useSelector(selectLanguagePopup);
  const aiCertificationData = useSelector(selectAiCertificationData);
  const similarPeopleData: SimilarPeopleData = useSelector(selectSimilarPeopleData);
  const currentUrl = window.location.href;
  const { pathname, state } = useLocation();
  const startTime = getCurrentTime();
  const allowGilroyGlobalFlag = useSelector(selectShowGlobalGilroy);
  const chatbotAllowed = useSelector(selectShowChatbot);
  const isGuestUser = isGuest() || isGuestfromEmail();
  const [guestBanner, setGuestBanner] = useState<boolean>(false);
  const disclessPersonality = useSelector(selectDisclessPersonality);
  const personThemeResponse = useSelector(selectPersonThemes);
  const personThemeLoading = useSelector(selectThemeLoading);
  const personThemes = personThemeResponse?.themes;
  const personThemeResponseID = personThemeResponse?.responseId;
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const [text, setText] = useState('Know Your Buyers Before You Meet Them');
  const showDigestPopup: boolean = useSelector(selectShowDigestPopup);
  const screenName = useSelector(selectScreenName);
  const peopleCollection = useSelector(peopleData);
  const isPersonSearchLoaded = useSelector(selectPersonLoaded);
  const isGlobalSearchLoaded = useSelector(selectSearchLoaded);
  const searchLoading = useSelector(selectLoading);
  const personsToDisplay = peopleCollection?.persons;
  const { Header } = Layout;
  const searchTerm = searchParams.get('search');
  const personHeader = useRef<HTMLDivElement | null>(null);
  const [headerWidth, setHeaderWidth] = useState(0);
  const insightLoading = useSelector(selectInsightsLoading);
  const gilroyRef = useRef<HTMLDivElement>(null);
  const strategicHighlights = useSelector(selectCompanyStrategicHighlights) || [];
  const highlightsLoading = useSelector(strategicHighlightsLoading);
  const currentSection = useSelector(selectCurrentSections);

  useEffect(() => {
    if (!personHeader.current) return;
    const updateWidth = () => {
      if (personHeader.current) {
        setHeaderWidth(personHeader.current.offsetWidth);
      }
    };

    // Run once to initialize
    updateWidth();

    // Observe size changes
    const observer = new ResizeObserver(updateWidth);
    observer.observe(personHeader.current);

    // eslint-disable-next-line consistent-return
    return () => {
      observer.disconnect();
    };
  }, []);

  const texts = [
    'Know Your Buyers Before You Meet Them',
  ];
  const personPersonalityDescription = personProfileCard?.personalityTypes && personProfileCard?.personalityTypes[0] && personProfileCard?.personalityTypes[0]?.description || '';
  const prevUrl = state?.from;
  // instead add active state of bottom accordion
  const sectionFlag = (
    section === 'news'
    || section === 'videos');

  // const bookADemoURL = useSelector(selectBookADemoURL);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const idx: IDX = window.history.state as IDX;
  const index = idx?.idx || 0;

  const toggle = (flag: boolean) => {
    setOpenCreateModal(flag);
  };

  const handleFaqClick = (faq: string, faqIdx: number) => {
    flushSync(() => setGilroySeedPrompt(undefined));
    setGilroySeedPrompt(faq);

    // flurry event call
    dispatch(flurryActions.callFlurryEvent(
      valueToObject(`People_FAQ_${faqIdx}_clicked`, startTime, {
        personId,
        personType,
        host,
      }),
    ));
  };
  useEffect(() => {
    flushSync(() => {
      // Reset highlights to empty array and set loading true
      dispatch(companiesActions.setStrategicHighlights([]));
    });
    if (personProfileCardPersonId && personId && !loading) {
      dispatch(
        companiesActions.getStrategicHighlights({
          id: personProfileCardPersonId,
          type: 'person',
          key: 'person_strategic_highlights',
        })
      );
    }
  }, [personProfileCardPersonId]);

  const handleHighlightClick = (prompt: string) => {
    flushSync(() => setGilroySeedPrompt(prompt));
    setGilroySeedPrompt(prompt);
    dispatch(flurryActions.callFlurryEvent(
      valueToObject(`person_highlights_clicked`, startTime, {
        personProfileCardPersonId,
        personType,
        prompt,
        host,
      }),
    ));
  };

  const handleGilroyClose = () => {
    flushSync(() => setGilroySeedPrompt(undefined));
    setGilroySeedPrompt(undefined);
  };

  const tabs: TabsInterface = {
    strategichighlights: <StrategicHighlights strategicHighlights={strategicHighlights} onGilroyClose={handleGilroyClose} handleClick={handleHighlightClick} />,
    personalityinsights: <PersonalityInsight
      propColor={personProfileCard?.archeType?.color || ''}
      isDrag={(a: boolean) => {
        if (a) dispatch(groupActions.setDropComplete(false));
        setDragging(a);
      }}
      faqs={faqs}
      onFaqClick={handleFaqClick}
      companyName={personProfileCard?.companyName || ''}
    />,
    news: <PersonNews
      personId={personProfileCardPersonId}
      personType={personProfileCard?.personType}
      listview={isListView}
    />,
    videos: <PersonVideos
      personId={personProfileCardPersonId}
      personType={personProfileCard?.personType}
      listview={isListView}
    />,
    ...(!disclessPersonality && {
      career: (
        <PersonCareer
          personId={personProfileCardPersonId}
          personType={personProfileCard?.personType}
        />
      ),
    }),
    ...(!disclessPersonality && {
      personal: (
        <PersonalDetails
          personId={personProfileCardPersonId}
          personType={personProfileCard?.personType}
        />
      ),
    }),
  };

  const fetchPersonCriticalData = (pId: number, type: string) => {
    dispatch(personProfileActions.getPersonProfileInsights({
      personId: pId, type,
    }));
  };

  const fetchPersonSecondaryData = (pId: number, type: string) => {
    dispatch(personProfileActions.getPersonProfileNews({
      personId: pId, type, page: 1,
    }));
    dispatch(personProfileActions.getPersonProfileIntentData({
      personId: pId, type,
    }));
    dispatch(personProfileActions.getPersonWorkbenchStats(pId));
    dispatch(personProfileActions.getPersonProfileVideos(
      {
        personId: pId,
        type,
        page: 1,
        videos: true,
      },
    ));
  };

  const scheduleSecondaryPersonFetch = (pId: number, type: string) => {
    const run = () => fetchPersonSecondaryData(pId, type);
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(run);
    } else {
      window.setTimeout(run, 0);
    }
  };

  const dataFetch = (pId: number, type: string) => {
    fetchPersonCriticalData(pId, type);
    scheduleSecondaryPersonFetch(pId, type);
  };

  useEffect(() => {
    if (!isGuestUser) {
      if (personType === 'EXECUTIVE' && personId && personId !== personProfileCardPersonId) {
        dispatch(personProfileActions.getPersonFaqs({ personId }));
      }
      else if (personType === 'LIVESEARCH' && personProfileCardPersonId) {
        dispatch(personProfileActions.getPersonFaqs({ personId: personProfileCardPersonId }));
      }
    }
  }, [personId, personProfileCardPersonId, isGuestUser]);

  useEffect(() => {
    if (searchTerm && isSalesforce() && !personsToDisplay?.length) {
      dispatch(personProfileActions.setSalesForcePersonSearchLoading(true));
      const obj: SearchResultsRequest = {
        query: `person:${searchTerm}`,
        screenName,
        page: 1,
        defaultLanguage: getLangCookie(),
      };
      dispatch(searchActions.globalSearchResults(obj));
    }
  }, [searchTerm]);

  useEffect(() => {
    if (!searchLoading && isGlobalSearchLoaded && isSalesforce() && searchTerm?.length) {
      if (personsToDisplay?.length === 0 && isPersonSearchLoaded) {
        setIsPersonSearchVisible(true);
      }
    }
  }, [isGlobalSearchLoaded, isPersonSearchLoaded]);

  useEffect(() => {
    if (isSalesforce() && searchTerm?.length) {
      if (personsToDisplay?.length === 1) {
        const [person] = personsToDisplay;
        navigate(`${PERSONALITY_INSIGHTS_ROUTE}${person.personId}&personType=${person.personType || 'EXECUTIVE'}`, { replace: true });
        setBackNavigation(-2);
      } else if (personsToDisplay && personsToDisplay?.length > 1) {
        setIsPersonSearchVisible(true);
      }
    }
  }, [personsToDisplay, searchTerm]);

  useEffect(() => {
    if (!isGuestUser) {
      if (personType === 'EXECUTIVE' && personId && personId !== personProfileCardPersonId) {
        dispatch(personProfileActions.getPersonFaqs({ personId }));
      }
      else if (personType === 'LIVESEARCH' && personProfileCardPersonId) {
        dispatch(personProfileActions.getPersonFaqs({ personId: personProfileCardPersonId }));
      }
    }
  }, [personId, personProfileCardPersonId, isGuestUser]);

  useEffect(() => {
    if (searchTerm && isSalesforce() && !personsToDisplay?.length) {
      dispatch(personProfileActions.setSalesForcePersonSearchLoading(true));
      const obj: SearchResultsRequest = {
        query: `person:${searchTerm}`,
        screenName,
        page: 1,
        defaultLanguage: getLangCookie(),
      };
      dispatch(searchActions.globalSearchResults(obj));
    }
  }, [searchTerm]);

  useEffect(() => {
    if (!searchLoading && isGlobalSearchLoaded && isSalesforce() && searchTerm?.length) {
      if (personsToDisplay?.length === 0 && isPersonSearchLoaded) {
        setIsPersonSearchVisible(true);
      }
    }
  }, [isGlobalSearchLoaded, isPersonSearchLoaded]);

  useEffect(() => {
    if (isSalesforce() && searchTerm?.length) {
      if (personsToDisplay?.length === 1) {
        const [person] = personsToDisplay;
        navigate(`${PERSONALITY_INSIGHTS_ROUTE}${person.personId}&personType=${person.personType || 'EXECUTIVE'}`, { replace: true });
        setBackNavigation(-2);
      } else if (personsToDisplay && personsToDisplay?.length > 1) {
        setIsPersonSearchVisible(true);
      }
    }
  }, [personsToDisplay, searchTerm]);

  useEffect(() => {
    if (isGuestUser) {
      dispatch(guestActions.getGuestUserData({
        finger_print: FingerPrint,
        first_name: 'Guest',
        last_name: 'User',
        company_name: '',
        email: 'guest@xiqinc.com',
        username: 'guest@xiqinc.com',
      }));
    }
  }, []);

  useEffect(() => {
    const isViewInsights = searchParams.get('viewInsights') === 'true';
    if (isViewInsights && !insightLoading) {
      smoothBehavior(scrollToId);
      replaceURLWithoutReload("viewInsights", 'false');
    }
  }, [scrollToId, insightLoading]);

  const guestLoginData: GuestLoginDataResponse = useSelector(selectLoginResp);

  const initialCall = () => {
    notification.destroy();
    const obj: GetPersonProfileRequest = {
      personId,
      type: personType,
      ...(isGuestUser && { finger_print: FingerPrint }),
    };
    if (personId > 0 && personProfileCardPersonId !== personId) {
      dispatch(personProfileActions.resetWithoutSimiarPeople());
      dispatch(affinitySearchActions.affinitySearchResultReset());
      dispatch(personProfileActions.getPersonProfile({
        ...obj,
        ...(dataParsed?.source && {
          source: dataParsed?.source,
        }),
      }));
      dispatch(UiAction.isShowUnderstandBlip(1));
      dataFetch(personId, personType);
      socket.disconnect();
    }
  };

  useEffect(() => {
    if (!isEmpty(guestLoginData)) {
      setLocalStorageValue('csrfToken', guestLoginData.csrfToken);
      setLocalStorageValue('username', guestLoginData.email);
      if (guestLoginData.skipOnBoarding) {
        setLocalStorageValue('skipOnBoarding', '1');
      }
      initialCall();
    }
  }, [guestLoginData]);

  useEffect(() => {
    if (section === 'personalityinsights' && prevSection?.length && section !== prevSection && !similarPeopleData?.loaded && personType === 'EXECUTIVE' && personId) {
      dispatch(personProfileActions.getSimilarPeople({ personId, type: personType, page: 1 }));
    }
  }, [section]);

  useEffect(() => {
    const href = window.location.href;
    const savedUrl = chatStates.saveUrl;
    const isGilroyReturn = Boolean(savedUrl) && savedUrl === href;
    const hasLoadedCardForPerson = Number(personProfileCardPersonId) === personId
      && Boolean(personProfileCard?.personId);
    const shouldFetchProfile = personId > 0
      && !isGuestUser
      && !hasLoadedCardForPerson;

    const obj: GetPersonProfileRequest = {
      personId,
      type: personType,
      ...(isGuestUser && { finger_print: FingerPrint }),
    };

    if (!isGilroyReturn) {
      dispatch(UiAction.isShowGilroyGlobalToggle(false));
      chatActions.setShowLibrary(true);
      chatActions.setShowExamplePrompts(false);
      chatActions.resetChatHistory();
      chatActions.setSelectedConversationId(-1);
      chatActions.setHistoryPanelOpened(false);
    }

    if (shouldFetchProfile) {
      socket.disconnect();
      dispatch(personProfileActions.reset());
      dispatch(affinitySearchActions.affinitySearchResultReset());
      if (!isGuestUser) {
        dispatch(personProfileActions.getPersonProfile({
          ...obj,
          ...(dataParsed?.source && {
            source: dataParsed?.source,
          }),
        }));
        dispatch(UiAction.isShowUnderstandBlip(1));
      }

      if (personType !== 'LIVESEARCH') {
        dataFetch(personId, personType);
      }
      dispatch(UiAction.isShowGilroyGlobalToggle(false));
      chatActions.setShowLibrary(true);
      chatActions.setShowExamplePrompts(false);
      chatActions.resetChatHistory();
      chatActions.setSelectedConversationId(-1);
      chatActions.setHistoryPanelOpened(false);
    }
    //dispatch(personProfileActions.getPersonTheme(themeObj));
    if (currentUrl === savedUrlV2) {
      chatActions.setSaveUrl('');
      chatActions.setSaveProfileName('');
      let eventName = '';
      switch (true) {
        case href.includes('/career'):
          eventName = 'executive_career';
          break;
        case href.includes('/personal?'):
          eventName = 'executive_profile_details';
          break;
        default:
          eventName = '';
      }
      dispatch(flurryActions.callFlurryEvent(
        valueToObject('executive_page_load', startTime, {
          ...obj,
          ...(obj.source && {
            article_entity_name: personProfileCard.personName,
          }),
          person_name: personProfileCard.personName,
          personId: personProfileCard.personId,
          type: personProfileCard.personType,
        }),
      ));
      if (eventName.length) {
        dispatch(flurryActions.callFlurryEvent(
          valueToObject(eventName, startTime, {
          }),
        ));
      }
    }
  }, [personId, personType]);
  useEffect(
    () => () => {
      const path = window.location.pathname;
      const isLeavingPersonFlow = !path.includes('/person/')
        && !path.includes('similarpeople')
        && !path.includes('document');
      if (isLeavingPersonFlow) {
        socket.disconnect();
        dispatch(personProfileActions.reset());
        dispatch(groupActions.reset());
        dispatch(affinitySearchActions.affinitySearchResultReset());
        dispatch(personProfileActions.saveProfile(0));
        dispatch(personProfileActions.setIsRecommended(false));
      }
    },
    [],
  );
  const onClickCancel = () => {
    setShowPopup(false);
  };

  const socketToasterContent = (message?: string) => (
    <div className="socket-toaster">
      <Spin />
      <span className="skt-heading">{message}</span>
    </div>
  );
  const redirectionAfterUpdateProfile = (d: string) => {
    const personObject: PersonObj = JSON.parse(d) as PersonObj;
    if (personObject && personObject?.personid) {
      notification.destroy();
      if (personType === 'LIVESEARCH') { navigate(`${PERSONALITY_INSIGHTS_ROUTE}${personObject.personid || ''}&personType=EXECUTIVE`, { replace: true }); } else if (!isGuestUser) initialCall();
      socket.removeListener();
      socket.disconnect();
    }
  };
  useEffect(() => {
    if (personProfileCardPersonId && personProfileCard) {
      if (personProfileCard.personRefresh || personProfileCard.personSearch) {
        socket.connect();
        dispatch(helperActions.setNotification({
          message: socketToasterContent(personProfileCard.notification),
          proTip: false,
          rightPlacement: false,
          groupId: 0,
          classnameFlag: true,
          className: 'socketNotification',
        }));
        socket.emit('searchperson', {
          personid: personProfileCardPersonId,
          username: localStorage.getItem('email'),
          identifier: 'xiQwebapp',
          environment: 'PROD',
        });
        socket.on('profileready', (d: string) => redirectionAfterUpdateProfile(d));
      }
      if (personType === 'LIVESEARCH' && personId !== savedId && !isGuestUser) { dataFetch(personProfileCardPersonId, personProfileCard?.personType); }
    }
    if (personProfileCardPersonId) {
      dispatch(certificationActions.aiCertificationAction({
        type: 'open_person_profile',
        source: 'person_gilroy',
        data: aiCertificationData,
      }));
    }
  }, [personProfileCardPersonId]);

  const handleFollowUnfollowPerson = () => {
    const obj: UpdatePersonProfileFollow = {
      personId: personProfileCard.personId,
    } as UpdatePersonProfileFollow;
    if (personProfileCard?.personAdded) {
      obj.feedids = [personProfileCard.personId];
      obj.type = personProfileCard.personType;
    } else {
      obj.person_data = [{
        type: personProfileCard.personType,
        query: personProfileCard.personName,
        entity_id: personProfileCard.personId,
      }];
    }
    dispatch(personProfileActions.updatePersonProfileFollow(obj));
  };

  const downloadPersonProfile = (language: string) => {
    setShowPopup(false);
    if (personProfileCard?.personId) {
      dispatch(personProfileActions.getPersonProfileDownload({
        personId: personProfileCard.personId,
        person_name: personProfileCard.personName,
        selected_language: language,
      }));
    }
    dispatch(certificationActions.certificationAction({
      type: 'person_download_header',
      source: 'person',
      data,
    }));
  };

  const checkProfileDownloadLanguage = () => {
    if (isLanguagePopup) {
      setShowPopup(true);
    } else {
      downloadPersonProfile(LanguageEnum.ENGLISH);
    }
  };

  useEffect(() => {
    setShowNew(false);
    setOpenCreateModal(dragging);
  }, [dragging]);

  useEffect(() => {
    dispatch(UiAction.isTabView({
      view: getPath.view,
    }));
  }, [getPath.view]);

  const isDrag = (a: boolean) => {
    if (a) dispatch(groupActions.setDropComplete(false));
    setDragging(a);
  };

  useEffect(() => {
    if (pathname.includes('personalityinsights')) {
      dispatch(certificationActions.certificationAction({
        type: 'person_insights',
        source: 'person',
        data,
      }));
    }
  }, []);

  useEffect(() => {
    if (isSearchPerson) {
      dispatch(certificationActions.certificationAction({
        type: 'person_select',
        source: 'search',
        data,
      }));
      dispatch(certificationActions.setSearchPersonClicked(false));
    }
  }, [isSearchPerson]);

  useEffect(() => {
    if (isScroll && scrollToPage.includes('/person/') && currentType !== 'affinity_section') {
      certificationSmoothBehavior(scrollToId);
      dispatch(certificationActions.setIsScroll(false));
    }
  }, [scrollToId, isScroll]);

  useEffect(() => {
    if (!isHighlighted && !isScroll && currentType === 'personality_insights') {
      dispatch(certificationActions.setHighlight(true));
      dispatch(certificationActions.setIsHighlighted(false));
    }
  }, [isScroll, currentType]);

  useEffect(() => {
    if (isToaster && data.personId === personId && navArray.length < 6 && currentType === 'person_insights') {
      dispatch(flurryActions.setNotification({
        message: PERSON_TOASTER,
        proTip: true,
        rightPlacement: false,
        groupId: 0,
        classnameFlag: true,
        certification: true,
        type: 'person',
      }));
      if (toasterFlag) {
        dispatch(certificationActions.setToasterFlag(false));
      }
    } else {
      dispatch(flurryActions.setNotification({
        message: '',
        proTip: false,
        rightPlacement: false,
        groupId: 0,
        classnameFlag: false,
      }));
    }
  }, [data.personId, currentType, navArray, personId, isToaster]);

  useEffect(() => {
    if (data.personId !== personId) {
      notification.destroy();
    }
  }, [personId]);

  useEffect(
    () => () => {
      dispatch(flurryActions.setNotification({
        message: '',
        proTip: false,
        rightPlacement: false,
        groupId: 0,
        classnameFlag: false,
      }));
      notification.destroy();
    },
    [],
  );

  useEffect(() => {
    setIsToaster(toasterFlag);
  }, [toasterFlag]);

  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    if (!guestBanner && personProfileCard?.personId) {
      timeoutRef.current = setTimeout(() => {
        setGuestBanner(true);
        const randomIndex = Math.floor(Math.random() * texts.length);
        setText(texts[randomIndex]);
      }, 15000);
    }
    return () => {
      if (timeoutRef.current !== null) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [personProfileCard]);

  const TagPerson: TagItem = {
    type: 'person',
    personType: personType === 'LIVESEARCH' ? 'LIVESEARCH' : 'EXECUTIVE',
    id: personProfileCard?.personId,
    name: personProfileCard?.personName,
    image: personProfileCard?.personImage,
    color: personProfileCard?.archeType?.color,
    personDesignation: personProfileCard?.personDesignation,
    ...(personProfileCard?.companyId && personProfileCard?.companyId !== 1880420 && {
      personCompany: {
        type: 'company',
        id: personProfileCard.companyId,
        name: personProfileCard.companyName || '',
        image: personProfileCard.companyLogo || '',
        color: personProfileCard.companyPersonality?.[0]?.color || '',
        companyPersonality: personProfileCard.companyPersonality,
        companyPulse: personProfileCard.companyPulse,
      },
    }),
  };
  const onBannerCTAClick = () => {
    const queryString = getStringAfterQueryParam('isGuest=true');
    const meetingLink = `${BOOK_A_MEETING_LINK}${queryString ? queryString.replace('&', '?') : ''}`;
    window.open(meetingLink);
  };
  const filteredArray: string[] = navArray
    .map((x) => {
      if (x === 'xiQ insights' && disclessPersonality) {
        return 'About';
      }
      if ((x === 'Career' || x === 'Personal') && disclessPersonality) {
        return null;
      }
      if (x === 'Strategic Highlights' && (strategicHighlights?.length === 0 || isGuestUser)) {
        return null;
      }
      return x;
    })
    .filter((x): x is string => x !== null);

  const createDigest = (themeId: string) => {
    if (personProfileCard?.personId) {
      dispatch(personProfileActions.createAIDigest({
        personId: personProfileCard.personId,
        themeId,
        responseId: personThemeResponseID,
        ...(personProfileCard?.email && { emailAddress: personProfileCard.email }),
      }));
    } else {
      dispatch(flurryActions.setNotification({
        message: DIGEST_FAILED_TOASTER,
        proTip: false,
        rightPlacement: false,
        groupId: 0,
        classnameFlag: false,
      }));
    }
  };

  // Add this useEffect to detect clicks outside Gilroy
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (gilroyRef.current && !gilroyRef.current.contains(event.target as Node)) {
        // Call the callback when clicking outside
        handleGilroyClose();
      }
    };

    // Only add listener when Gilroy is visible
    if (allowGilroyGlobalFlag && chatbotAllowed && TagPerson?.id) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [chatbotAllowed, allowGilroyGlobalFlag, TagPerson?.id]);

  useEffect(() => {
    if (currentSection.includes('Strategic Highlights') && section !== 'personalityinsights') dispatch(personProfileActions.removeCurrentSection('Strategic Highlights'));
    if (currentSection) {
      if (currentSection.includes('Strategic Highlights')) {
        dispatch(personProfileActions.removeCurrentSection('xiQ insights'));
      }
      if (prevSection === 'strategichighlights') {
        dispatch(personProfileActions.removeCurrentSection('Strategic Highlights'));
      }
    }
  }, [currentSection, prevSection]);

  const tabToHighlight = () => {
    if (currentSection.includes('xiQ insights')) {
      return 'xiQ insights';
    } else if (currentSection.includes('Strategic Highlights')) {
      return 'Strategic Highlights';
    }
    return 'undefined';
  };

  const handleGilroyStrategyClick = (prompt: string) => {
    const promptWithTag = `${prompt} ${normalizeTagItemToSpan(TagPerson)}`;
    flushSync(() => setGilroySeedPrompt(promptWithTag));
    setGilroySeedPrompt(promptWithTag);

    const promptEvent = prompt.replace(/\s+/g, '_').toLowerCase();
    dispatch(flurryActions.callFlurryEvent(
      valueToObject(`Person_profile_${promptEvent}`, startTime, {
        personId,
        personType,
        host,
      }),
    ));
    dispatch(UiAction.isShowUnderstandBlip(0));
  };

  return (
    <Wrapper
      className={classNames({ nutenixPerson: disclessPersonality })}
      personHeader={headerWidth}
    >
      <PersonStyle />
      <FeedStyle />
      {isGuestUser
        ? (
          <>
            <AlertsStyle />
            <Header className={classNames(
              'header-main-wrapper no-overflow-on-header',
            )}
            >
              <div className="container h-100 o-revert">
                <div className="header-wrapper">
                  <div className="left-side-wrap">
                    {
                      !guestBanner && personPersonalityDescription.length ? (
                        <>
                          <GuestBanner
                            personPersonality={personPersonalityDescription}
                            loading={loading || guestLoading}
                            text={text}
                            onCTAClick={onBannerCTAClick}
                          />
                          <GuestPopup
                            setGuestBanner={() => setGuestBanner(false)}
                            personPersonality={personPersonalityDescription}
                            loading={loading || guestLoading}
                            text={text}
                            guestBanner={guestBanner}
                          />
                        </>
                      ) : null
                    }
                    {index > 0 ? <BackIcon onClick={() => navigate(-1)} /> : null}
                    {loading || guestLoading ? (
                      <SkeletonCustom
                        width="320px"
                        height="30px"
                        margin="0px 0px 0px 5px"
                      />
                    ) : (
                      <h1 className={classNames(
                        'heading text-truncate-two-line',
                        { guestUser: index === 0 },
                      )}
                      >
                        {personProfileCard && personProfileCard.personName}
                      </h1>
                    )}
                  </div>
                  <div className={classNames('right-side-wrap', { guestHeader: isGuestUser })}>
                    {guestLoading || loading ? null : (
                      <GlobalButton
                        title="Schedule a Demo"
                        bgColor={primaryColor}
                        textColor="#fff"
                        outlineColor={primaryColor}
                        IconLeft={<MeetingIcon color="#fff" />}
                        PaddingSm="5px 10px"
                        innerSpace="5px 10px"
                        heightSm="30px"
                        onButtonClick={onBannerCTAClick}
                        buttonClassName="schedule-demo-btn"
                        disabled={false}
                        height="35px"
                      />
                    )}
                  </div>
                </div>
              </div>
            </Header>
            <SubNavBarPrimary>
              <div className="heading-inner-page tabs-placeholder wrap-slider hidden-scroll">
                <div className="head-wrap" />
                <div className="tips-placeholder">
                  <Tabs
                    baseComponentPath="person"
                    tabsName={filteredArray}
                    loading={loading || guestLoading}
                    elementTarget="tabs-details"
                    headerAppendTab
                    fromPersonTab
                  />
                </div>
                <div className="right-side-sub-header">
                  <div className={classNames('view-tabs', {
                    notdisabledTabs: sectionFlag,
                  })}
                  >
                    <ViewTabs
                      disabled={!sectionFlag}
                      listView={isListView}
                    />
                  </div>
                </div>
              </div>

            </SubNavBarPrimary>
          </>
        )
        : (
          <>
            <NavBarPrimary headerClassName="no-overflow-on-header">
              <div className="left-side-wrap">
                <BackIcon onClick={() => { navigate(backNavigation); }} />
                {loading || guestLoading ? (
                  <SkeletonCustom
                    width="340px"
                    smWidth="150px"
                    height="30px"
                    margin="0px 0px 0px 5px"
                  />
                ) : (
                  <h1 className="heading text-truncate-two-line">
                    {personProfileCard && personProfileCard.personName}
                  </h1>
                )}
              </div>
              <div className="right-side-wrap" ref={personHeader}>
                <GlobalSearch iconMode={IsTab} />

                <DrawerAlerts />
                <AccountPopOver />
              </div>
            </NavBarPrimary>
            {(CardResult[0]?.data?.length === 0 && !loading)
              || (!loading
                && CardResult[1]?.details?.length === 0)
              ? null
              : (
                <SubNavBarPrimary>
                  <div className="heading-inner-page tabs-placeholder wrap-slider hidden-scroll">
                    <div className="head-wrap" />
                    <div className="tips-placeholder">
                      <Tabs
                        baseComponentPath="person"
                        tabsName={filteredArray}
                        loading={loading || guestLoading}
                        elementTarget="tabs-details"
                        headerAppendTab
                        fromPersonTab
                        strategicHighlightsIconProp={blip}
                        companyActiveTab={tabToHighlight()}
                        personActiveTab={tabToHighlight()}
                        currentSection={currentSection}
                      />
                    </div>
                    <div className="right-side-sub-header">
                      <div className={classNames('view-tabs', {
                        notdisabledTabs: sectionFlag,
                      })}
                      >
                        <ViewTabs
                          disabled={!sectionFlag}
                          listView={isListView}
                        />
                      </div>
                    </div>
                  </div>

                </SubNavBarPrimary>
              )}
          </>
        )}
      {allowGilroyGlobalFlag && chatbotAllowed && TagPerson?.id ? (
        <div ref={gilroyRef} className="container chatbot-container">
          {
            disclessPersonality ? (
              <Gilroy
                gilroyStates={gilroyStates}
                gilroyActions={gilroyActions}
                isGilroyV2
                tagItem={TagPerson}
              >
                {IsTab ? (
                  <GilroyPersonHeader
                    {...personProfileCard}
                    socialLinks={{ data: personProfileSocialLinks }}
                    personFollowLoading={personProfileFollowLoading}
                    onClickHandler={handleFollowUnfollowPerson}
                    personAdded={personProfileCard?.personAdded}
                    personInfo={personProfileCard}
                    hideFollow={isGuestUser}
                  />
                ) : (
                  <PersonInfo
                    {...personProfileCard}
                    personInfo={personProfileCard}
                    socialLinks={{ data: personProfileSocialLinks }}
                    onClickHandler={handleFollowUnfollowPerson}
                    personAdded={personProfileCard?.personAdded}
                    personFollowLoading={personProfileFollowLoading}
                    isPersonMainCard
                    hideFollow={isGuestUser}
                    customClassName="person-page-header"
                    disclessFlag={disclessPersonality}
                    isDrag={isDrag}
                  />
                )}
              </Gilroy>
            )
              : <Gilroy
                gilroyStates={gilroyStates}
                gilroyActions={gilroyActions}
                tagItem={TagPerson}
                seedPrompt={gilroySeedPrompt}
              />
          }
        </div>
      ) : null}
      <div className={classNames('container')}>
        {!isGuestUser ? (
          <DrawerPeopleGroup
            openNewCreate={openCreateModal}
            setOpenNew={toggle}
            showNew={showNew}
            toggleShowNew={(bool: boolean) => setShowNew(bool)}
            noButton
            drag={dragging}
          />
        ) : null}
        {(CardResult[0]?.data?.length === 0 && !loading)
          || (!loading
            && CardResult[1]?.details?.length === 0)
          ? (
            <NoDataFound
              title="No data found. Try again later."
            />
          )
          : (
            <>
              {isGuestUser && personPopups.showPlanPopup === 1
                ? <LimitReached popupResponse={personPopups} /> : (
                  personPopups.showPlanPopup >= 0 && (
                    <ProfilePopups
                      personId={personProfileCardPersonId}
                      title={personPopups.popupHeading}
                      description={personPopups.popupText}
                      type={personPopups.showPlanPopup}
                      callToAction={personPopups.callToAction}
                      contactUs={`${personPopups.contactusEmail}`}
                      isDownloadPopup={personPopups.isDownloadPopup}
                      loading={personDownloadLoading}
                    />
                  )
                )}
              {loading || guestLoading ? (
                <div className="container-company-card loader-skeleton">
                  {IsTab ? (
                    <SkeletonCustom
                      height="400px"
                      width="100%"
                      logo
                      margin="0px 0px 0px 0px"
                      marginSm="0px 0px 0px 0px"
                      className="skeleton"
                    />
                  ) : <PersonCardSkeleton disclessPersonality />}
                </div>
              ) : disclessPersonality ? null : (
                <div
                  id="certification-person-header"
                  className={classNames('container-company-card main-company-panel', { highlightedComponent: isHighlight && currentType === 'personality_insights' })}
                >
                  {personProfileCard?.personId || loading
                    ? (
                      <>
                        <Row className="person-info-detail-row">
                          <Col
                            xxl={{ span: 6 }}
                            xl={{ span: 8 }}
                            lg={{ span: 8 }}
                            md={{ span: 8 }}
                            sm={{ span: 24 }}
                            xs={{ span: 24 }}
                            className="first-col-area"
                          >
                            <PersonInfo
                              {...personProfileCard}
                              personInfo={personProfileCard}
                              socialLinks={{ data: personProfileSocialLinks }}
                              onClickHandler={handleFollowUnfollowPerson}
                              personAdded={personProfileCard?.personAdded}
                              personFollowLoading={personProfileFollowLoading}
                              isPersonMainCard
                              hideFollow={isGuestUser}
                              isDrag={isDrag}
                            />
                          </Col>
                          <Col
                            xxl={{ span: 18 }}
                            xl={{ span: 16 }}
                            lg={{ span: 16 }}
                            md={{ span: 16 }}
                            sm={{ span: 24 }}
                            xs={{ span: 24 }}
                            className="second-col-area"
                          >
                            <PersonDetails
                              personInfo={personProfileCard}
                              {...personProfilePersonalityInfo}
                              personaColor={personProfileCard?.archeType?.color}
                              socialLinks={{ data: personProfileSocialLinks }}
                              personality={personProfileCard?.archeType?.personality}
                              personDownloadLoading={personDownloadLoading}
                              onDownloadProfileClick={checkProfileDownloadLanguage}
                              isGuestUser={isGuestUser}
                              handleGilroyStrategyClick={handleGilroyStrategyClick}
                            />
                          </Col>
                        </Row>
                        <DisclaimerMessage label={DISCLAIMER_MESSAGE} className="main-card-spacing" />
                      </>
                    )
                    : <PersonCardSkeleton disclessPersonality />}
                </div>
              )}
            </>
          )}
        {
          useMemo(
            () => ((CardResult[0]?.data?.length === 0 && !loading) || (!loading && CardResult[1]?.details?.length === 0)
              ? null
              : (
                <>
                  {!isGuestUser ? <>
                    {allowGilroyGlobalFlag && chatbotAllowed && !highlightsLoading && strategicHighlights?.length > 0 ? (
                      <div className='person-highlights-wrapper'>
                        {((section || 'personalityinsights') === 'personalityinsights') ? (
                          <StrategicHighlights strategicHighlights={strategicHighlights} handleClick={handleHighlightClick} />
                        ) : null}
                      </div>
                    ) : (
                      (!highlightsLoading && strategicHighlights?.length === 0)
                        ? null
                        : <StrategicHighlightsSkeleton />
                    )}
                  </> : null}
                  <div className="tabSection" id="tabs-details">
                    {tabs[section || 'personalityinsights']}
                  </div>
                </>
              )),
            [section, personProfileCard, isListView, faqs, strategicHighlights],
          )
        }
      </div >

      <DownloadProfileLanguagePopup
        showPopup={showPopup}
        onClickCancel={onClickCancel}
        downloadPersonProfile={downloadPersonProfile}
      />
      <GenerateDigestPopup isIpPopup={showDigestPopup} />
      {
        isSalesforce() ? (
          <SearchResultPopup
            type="person"
            count={peopleCollection?.count}
            searchQuery={searchTerm || ''}
            persons={personsToDisplay || []}
            isVisible={isPersonSearchVisible}
            setIsVisible={setIsPersonSearchVisible}
          />
        ) : null
      }
    </Wrapper >
  );
};

export default Person;
